const apiUrl = process.env.REACT_APP_API_URL;
export const PostJutgeProblemaIdUsuariId = async (id_problema: string, id_usuari: string, uid: string, id_activitat: string, origen: string = 'WEB_NORMAL') => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/activitats/${id_activitat}/problemes/${id_problema}/usuaris/${id_usuari}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ uid, origen })
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
